import { Fragment, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../state/actions";
import LazyLoadImg from "../../shared/lazyLoadImg/LazyLoadImg";
import CustomButton from "../../shared/customButton/CustomButton";
import { BASENAME } from "../../../utils/basename";
import { URLASSOLUTO } from "../../../utils/urlassoluto";
import { BASESTORAGE } from "../../../utils/basestorage";
// la scheda del pacchetto è costituita da
// titolo Pacchetto in lingua -> ok
// immagine del primo dei prodotti
// elenco nomi dei prodotti
// cifra totale
// bottone
const PackageBoxDetailItem = ({
  packageId,
  immagine,
  titolo = null,
  titoloCategoria = null,
  sottotitolo = null,
  prezzoOriginale = null,
  prezzo = null,
  colore,
  routeName = null,
  linkSeo = null,
  richiediInfo = null,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentLang = useSelector((state) => state.currentPage.currentLang);
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  useEffect(() => {
    console.log("PackageBoxDetailItem");
  });

  const onPackageClick = (event) => {
    event.preventDefault();

    // mostro spinner
    dispatch(allActions.isFetchingAction.loadSpinner());

    dispatch(
      allActions.changePageActions.changePage(
        packageId,
        routeName,
        linkSeo,
        history
      )
    );
  };

  const immagineElenco =
    immagine === null || immagine?.file_name === undefined ? (
      <LazyLoadImg
        imgName="placeholder_elenco_prodotto.jpg"
        imgPath="statiche"
        imgWidth="300"
        imgHeight="232"
        imgStyle="flex-start mb-3 w-full object-fit cursor-pointer"
        imgAlt={titolo}
      />
    ) : (
      <LazyLoadImg
        imgName={`300x232-${immagine.file_name.replace(".jpg", ".webp")}`}
        imgPath={`${immagine.folder}/thumbs`}
        imgWidth="300"
        imgHeight="232"
        imgStyle="flex-start mb-3 w-full object-fit cursor-pointer"
        imgAlt={titolo}
      />
    );

  const titoloCategoriaToShow = titoloCategoria ? titoloCategoria : "";

  const titoloFormatted = (
    <span
      className={`titolo leading-tight line-clamp-3 block text-${colore} mb-3`}
      dangerouslySetInnerHTML={{
        __html: titolo,
      }}
    ></span>
  );

  const prezzoProdottoOriginale = (
    <span className="prezzoScontato flex">
      {parseFloat(prezzoOriginale).toFixed(2).toString().replace(".", ",")}€
    </span>
  );

  const prezzoProdotto = (
    <span className="prezzoProdotto flex text-ribola-web-orange text-3xl">
      {parseFloat(prezzo).toFixed(2).toString().replace(".", ",")}€
    </span>
  );

  const pulsanteLink =
    richiediInfo === 1 ? (
      <CustomButton
        buttonId={packageId}
        buttonLink={linkSeo}
        buttonRouteName={routeName}
        buttonOnClickFunction={onProductClick}
        buttonName={genericheTranslation.richiediinformazioni.itemName}
        buttonStyle="dettagliButton richiediInfo text-sm pl-4 pr-16 py-2 3xl:py-3 mt-2"
      />
    ) : (
      <CustomButton
        buttonId={packageId}
        buttonLink={linkSeo}
        buttonRouteName={routeName}
        buttonOnClickFunction={onPackageClick}
        buttonName={genericheTranslation.dettagli.itemName}
        buttonStyle="dettagliButton text-sm pl-4 pr-16 py-2 3xl:py-3 mt-2"
      />
    );

  return (
    <div className="col-span-60 sm:col-span-30 md:col-span-20 xl:col-span-15 mb-10 flex justify-center">
      <div className="productBoxItem border-t border-gray-200 max-w-xs sm:max-w-none mx-8 sm:mx-4 md:mx-2 lg:mx-3 xl:mx-2 4xl:mx-4">
        <div>
          <a
            href={URLASSOLUTO + linkSeo}
            onClick={onPackageClick}
            className="text-lg md:text-sm 3xl:text-base sm:h-20 block"
          >
            {titoloFormatted}
          </a>
          <a
            href={URLASSOLUTO + linkSeo}
            onClick={onPackageClick}
            className="block h-52 overflow-hidden mb-2"
          >
            {immagineElenco}
          </a>
          <div
            className="sottotitolo text-sm block"
            dangerouslySetInnerHTML={{
              __html: sottotitolo,
            }}
          />
        </div>
        <div>
          {!richiediInfo ? prezzoProdottoOriginale : ""}
          {!richiediInfo ? prezzoProdotto : ""}
          {pulsanteLink}
        </div>
      </div>
    </div>
  );
};

export default PackageBoxDetailItem;
